module.exports = __webpack_public_path__ + "img/4f_r_jindaiji@2x.1ac5243c.png";